export default "__VITE_ASSET__Dkexiqdg__"